import React from 'react';
import {StyleSheet, View} from 'react-native';
import {Card} from '@rneui/themed';
import {observer} from 'mobx-react-lite';

import ZenGiftCardsManager from '../../../components/payments/zenGiftCards/ZenGiftCardsManager';
import Text from '../../../components/themed/Text';
import config from '../../../config';
import {useStores} from '../../../stores/use-stores';

export interface GiftCardsSectionProps {
  /** Test ID for the container */
  testID?: string;
}

/**
 * Gift cards section for checkout payment step.
 * Shows gift card manager and info message when gift cards are being used.
 *
 * Respects FF_IS_GIFT_CARDS_ENABLED feature flag.
 *
 * Consolidates duplicated rendering from:
 * - CheckoutPaymentScreen.tsx
 * - PaymentContent.tsx
 */
export const GiftCardsSection = observer(({testID}: GiftCardsSectionProps) => {
  const {cartStore} = useStores();
  const {isGiftCardsBeingUsed} = cartStore;

  // Feature flag check
  if (!config.FF_IS_GIFT_CARDS_ENABLED) {
    return null;
  }

  return (
    <View testID={testID} style={styles.container}>
      <ZenGiftCardsManager />

      {!!isGiftCardsBeingUsed && (
        <Card noMargin variant="information">
          <Text color="grey2" variant="body2">
            Any amount that is not covered by the gift card will be automatically charged to your
            nominated debit/credit card
          </Text>
        </Card>
      )}
    </View>
  );
});

const styles = StyleSheet.create({
  container: {
    gap: 16,
  },
});

export default GiftCardsSection;
